import * as React from 'react'
import AppFeatureEditor from '../AppFeatureEditor'
import {Feature} from '../../../core/models'
import {IFieldInfo} from '../../../core/interfaces/reducers'
import {ControlError} from '../../../core/components/FeatureViews/FeatureEditor'
import {IFeatureLayerInfo} from '../../../core/interfaces/models'
import OverlayLoader from '../../../core/components/Loading/OverlayLoading'
import {GeometryType} from '../../../core/enums/GeometryType'

class SiteLineFeatureEditor extends AppFeatureEditor {
  protected onFieldValueChange(fieldName: string, feature: Feature, fieldInfo: IFieldInfo, newValue: any) {
    feature.set(fieldName, newValue)
    this.applyChanges(feature)
    setTimeout(() => {
      this.save(feature)
    }, 100)
  }

  protected getNomenclatureEditingControl(
    currentValue: React.ReactText | undefined,
    fieldName: string,
    feature: Feature,
    fieldInfo: IFieldInfo,
    error: ControlError
  ) {
    return this.getControlStar(
      <select
        className="form-control"
        value={currentValue !== undefined && currentValue !== null && currentValue !== '' ? currentValue : ''}
        onChange={e => {
          this.onFieldValueChange(fieldName, feature, fieldInfo, e.target.value)
        }}
      >
        {this.getNomenclatureOptions(fieldInfo)}
      </select>,
      fieldInfo
    )
  }

  protected renderFeatures(feature: Feature, layerInfo: IFeatureLayerInfo): Array<JSX.Element> {
    const fields: Array<JSX.Element> = []
    const atts = feature.getProperties()
    for (const fieldName in layerInfo.fields) {
      const fieldInfo = layerInfo.fields[fieldName]
      if (this.processField(fieldInfo, layerInfo, feature)) {
        const currentValue = atts[fieldName] !== null || atts[fieldName] !== undefined ? atts[fieldName] : ''
        const error = this.controlHasErrors(currentValue, fieldInfo)
        fields.push(
          <div
            key={fieldName}
            style={{
              display: 'flex',
              alignItems: 'center',
              backgroundColor: error != ControlError.None && this.state.showGuiltyFields ? '#ff00000d' : '',
              padding: '4px'
            }}
          >
            {fieldInfo.fieldName == 'LineType' ? null : <div className="detail-line-td">{fieldInfo.label}</div>}
            <div className="detail-line-td" style={{width: '100%'}}>
              {this.getEditingControl(fieldName, feature, fieldInfo, layerInfo, error, currentValue)}
            </div>
          </div>
        )
      }
    }
    return fields
  }

  render() {
    const feature = this.props.editsDispatcher ? this.props.feature : this.state.feature
    return (
      <div
        style={{
          ...this.props.style,
          position: 'relative',
          height: '100%',
          marginTop: '-15px',
          marginBottom: '15px',
          overflow: 'hidden'
        }}
      >
        <div style={{margin: '10px'}}>
          <OverlayLoader size="60px" show={this.state.loading} />
          {this.props.saveControlsTop ? this.getSaveControls(feature) : null}
          {this.renderEditingBody(feature, this.props.layerInfo)}
          {this.props.layerInfo.getGeometryType() != GeometryType.None && !this.props.hideGeometrySelector
            ? this.getGeometryEditor(feature)
            : null}
          {this.props.layerInfo.sourceDescription.hasAttachments ? this.getAttachmentsViewer(feature) : null}
          {this.state.showGuiltyFields && this.controlsHaveErrors(feature) ? (
            <div className="error-div">Моля, оправете грешките</div>
          ) : null}
          {this.state.errorMessage ? <div className="error-div">{this.state.errorMessage}</div> : null}
          {this.props.saveControlsTop ? null : this.getSaveControls(feature)}
        </div>
      </div>
    )
  }
}

export default SiteLineFeatureEditor
